export const SCHEMATICS_GET_BEGIN = 'SCHEMATICS_GET_BEGIN';
export const SCHEMATICS_GET_SUCCESS = 'SCHEMATICS_GET_SUCCESS';
export const SCHEMATICS_GET_FAIL = 'SCHEMATICS_GET_FAIL';

export const SCHEMATICS_GET_PRICE_BEGIN = 'SCHEMATICS_GET_PRICE_BEGIN';
export const SCHEMATICS_GET_PRICE_SUCCESS = 'SCHEMATICS_GET_PRICE_SUCCESS';
export const SCHEMATICS_GET_PRICE_FAIL = 'SCHEMATICS_GET_PRICE_FAIL';
